import React from 'react';
import { observer } from 'mobx-react-lite';
import { gameStore } from '../../store/gameStore';
import { DECISION_NAME_BY_TYPE } from '../../enums/decisionTypes';
import { BLACK_JACK_POINT, SPLIT_HAND_TYPE } from '../../enums/constants';

const PlayerCardsPoint = observer(({ firsHand, secondHand, boxIndex }) => {
  const { activeBox, activeHandByBox } = gameStore;
  return (
    <div className='tb-player-points-wrapper'>
      {secondHand && (
        <div
          className={`tb-player-points
          ${secondHand.winAmount ? 'win' : ''}
          ${secondHand.isPush ? 'push' : ''}
          ${secondHand.point > BLACK_JACK_POINT ? 'blow-up' : ''}
          ${
            (activeHandByBox === SPLIT_HAND_TYPE && activeBox === boxIndex) ||
            (activeBox === null &&
              !secondHand.winAmount &&
              !secondHand.isPush &&
              secondHand.point <= BLACK_JACK_POINT)
              ? 'active'
              : 'inactive'
          }
          `}
        >
          <span
            className={`${secondHand?.secondPoint ? 'min-size-for-drop' : ''} ${
              activeBox === boxIndex ? `icon-${DECISION_NAME_BY_TYPE[secondHand.decision]}` : ''
            } `}
          >
            <i>
              {secondHand.secondPoint && activeBox === boxIndex ? `${secondHand.secondPoint}/` : ''}
              {secondHand.point}
            </i>
          </span>
        </div>
      )}
      {firsHand && (
        <div
          className={`tb-player-points 
          ${firsHand.isSurrender ? 'surrender' : ''}
          ${firsHand.winAmount && !firsHand.isSurrender && !firsHand.isPush ? 'win' : ''}
          ${firsHand.isPush ? 'push' : ''}
          ${firsHand.point > BLACK_JACK_POINT ? 'blow-up' : ''} 
          ${firsHand.hasBlackJack ? 'black-jack' : ''} 
          ${
            ((activeBox === boxIndex && !activeHandByBox) || activeBox === null) &&
            firsHand.point <= BLACK_JACK_POINT &&
            !firsHand.isSurrender &&
            !(
              firsHand.winAmount ||
              firsHand.isSurrender ||
              firsHand.isPush ||
              firsHand.hasBlackJack
            )
              ? 'active'
              : ''
          }`}
        >
          <span
            className={`${firsHand?.secondPoint ? 'min-size-for-drop' : ''} ${
              activeBox === boxIndex && activeHandByBox !== SPLIT_HAND_TYPE
                ? `icon-${DECISION_NAME_BY_TYPE[firsHand.decision]}`
                : ''
            }`}
          >
            <i>
              {firsHand.secondPoint ? `${firsHand.secondPoint}/` : ''}
              {firsHand.point}
            </i>
          </span>
        </div>
      )}
    </div>
  );
});

export default PlayerCardsPoint;
